<template>
  <div>
    <Head title="Work Order" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/work-orders">
        Work Orders
      </Link>
      <span class="text-orange-400 font-medium">/</span>Create
    </h1>
    <div class="max-w-full bg-white rounded-md shadow mb-3">
      <form @submit.prevent="store">
        <div class="pb-2 pr-6 w-full lg:w-full mb-8">
          <div class="flex flex-wrap -mb-16 -mr-6 p-8">
            <div class="pb-2 pr-6 w-full lg:w-1/2">
              <multiselect
                v-model="selectedProductionLine"
                id="production_line_id"
                placeholder="Select Production Line"
                :options="productionLines"
                :close-on-select="true"
                :searchable="true"
                :error="form.errors.production_line_id"
                :style= "form.errors.production_line_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                @search-change="onSearchProductionLineChange"
                @input="onSelectedProductionLine"
              />
              <div v-if="form.errors.production_line_id" class="form-error">{{ form.errors.production_line_id }}</div>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-1/2">
              <multiselect
                v-model="form.sku_id"
                id="sku_id"
                placeholder="Search SKU"
                :options="skus"
                :close-on-select="true"
                :searchable="true"
                :error="form.errors.sku_id"
                :style= "form.errors.sku_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                @search-change="onSearchSkusChange"
                @input="onSelectedSku"
              />
              <div v-if="form.errors.sku_id" class="form-error">{{ form.errors.sku_id }}</div>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-1/2">
              <multiselect
                v-model="form.bom_id"
                id="bom_id"
                placeholder="Search Bom"
                :options="boms"
                :close-on-select="true"
                :searchable="true"
                :error="form.errors.bom_id"
                :style= "form.errors.bom_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                @input="onSelectedBom"
              />
              <div v-if="form.errors.bom_id" class="form-error">{{ form.errors.bom_id }}</div>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-1/2">
              <text-input
                class="w-full lg:w-full"
                v-model="form.quantity"
                :error="form.errors.quantity"
                placeholder="Quantity"
              />
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button :loading="form.processing" class="btn-orange" type="submit">
            Add Work Order
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'
import throttle from 'lodash/throttle'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    filters: Object,
    skus: {
      type: Array,
      default: () => []
    },
    productionLines: Object,
    boms: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        production_line_id: null,
        sku_id: null,
        quantity: null,
        bom_id: null,
      }),
      selectedSku: null,
      selectedProductionLine: null,
    }
  },
  methods: {
    store() {
      this.form.post(`/work-orders`, {
        onSuccess: () => {
          this.form.reset(
            'quantity',
            'bom_id'
          )
        }
      })
    },
    onSearchSkusChange: throttle(function (search) {
        this.$inertia.get(`/work-orders/create`, {search, productionLine: this.selectedProductionLine, sku: this.selectedSku}, {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 200),
    onSelectedSku(sku, id) {
      this.form.sku_id = sku;
      this.selectedSku = sku
      this.$inertia.get('/work-orders/create', {productionLine: this.selectedProductionLine, sku: this.selectedSku}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    },
    onSelectedBom(bom, id) {
      this.form.bom_id = bom;
    },
    onSelectedProductionLine(productionLine, id) {
      this.form.production_line_id = productionLine;
      this.selectedProductionLine = productionLine
      this.$inertia.get('/work-orders/create', {productionLine: this.selectedProductionLine}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    },
    onSearchProductionLineChange: throttle(function (productionLine) {
      this.$inertia.get('/work-orders/create', {productionLine: this.selectedProductionLine}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 200),
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>